import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { FaRegEye } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import Select, { components } from 'react-select';
import { CiViewList } from "react-icons/ci";
import axios from "axios";
import { AiTwotoneEdit } from "react-icons/ai";
import { MdDeleteForever } from "react-icons/md";
import ConfirmDialog from '../../../components/ConfirmDialog';

const selectAllOption = { value: 'all', label: 'Select All' };

function CallDetail() {
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const [detail, setDetail] = useState([]);
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [step, setStep] = useState(1);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [user, setUser] = useState([]);
    const [selectedCall, setSelectedCall] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [calls, setCalls] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedCalls, setSelectedCalls] = useState([]);
    const [showModal, setShowModal] = React.useState(false);
    const [selectedRemark, setSelectedRemark] = React.useState("");

    const [stateOptions, setStateOptions] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [allBranches, setAllBranches] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [pincodeOptions, setPincodeOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [stateData, setStateData] = useState([]);
    const [selectedRowsByCity, setSelectedRowsByCity] = useState({});
    const [cityTableData, setCityTableData] = useState([]);

    const [selectedRegion, setSelectedRegion] = useState(null);
    const [regionOptions, setRegionOptions] = useState([]);
    const [callOptions, setCallOptions] = useState([]);
   
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const [editingId, setEditingId] = useState(null);
const [editForm, setEditForm] = useState({});

  const [form, setForm] = useState({
    name:'',
    number:'',
    address:"",
    state: '',
    city: '',
    region: '',
    pincode: ''
  })

    const options = user.map(t => ({
        value: t.id,
        label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
    }));

        const [confirmDialog, setConfirmDialog] = useState({
            show: false,
            title: '',
            message: '',
            onConfirm: null,
        });
    

    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };


    const updateStatus = async () => {
        try {
            const result = await axios.post("https://api.skyguard.group/api/update-data-sheet-call-status", {
                call_id: selectedCall.id,
                data_type: "rejected"
            });

            showToast("Call marked as not verified", "warning");
            setSelectedCall(null);
        } catch (err) {
            showToast("Failed to update status", "danger");
        }
    };



    const handleVerify = async () => {
        try {
            if (!selectedEmployee) {
                showToast("Please select employee", "danger");
                return;
            }

            const payload = {
                call_id: selectedCall.id,
                emp_id: selectedEmployee.value,
                data_type: "verified",
                call_data: selectedCall
            };

            await axios.post("https://api.skyguard.group/api/verify-call", payload);

            showToast("Call verified successfully!", "success");

            setShowVerifyModal(false);
            setSelectedEmployee(null);
            setSelectedCall(null);
            setSelectedCity([]);
            setSelectedState([]);
            setSelectedRegion([]);
        } catch (error) {
            showToast("Verification failed!", "danger");
        }
    };


    // const handleCityChange = (city) => {
    //     setSelectedCity(city);
    //     setSelectedRegion(null);

    //     if (!city) {
    //         setRegionOptions([]);
    //         return;
    //     }

    //     const regions = stateData
    //         .filter(item => item.city === city.value)
    //         .map(item => item.region);

    //     const uniqueRegions = [...new Set(regions)];

    //     const regionOptionsFormatted = uniqueRegions.map(region => ({
    //         value: region,
    //         label: region,
    //     }));

    //     setRegionOptions(regionOptionsFormatted);
    // };



const handleCityChange = (city) => {
    setSelectedCity(city);
    setSelectedRegion(null);
    setSelectedCalls([]);

    if (!city) {
        setRegionOptions([]);
        setCallOptions([]);
        return;
    }

    const regions = stateData
        .filter(item => item.city === city.value)
        .map(item => item.region);

    const uniqueRegions = [...new Set(regions)];

    setRegionOptions(
        uniqueRegions.map(region => ({
            value: region,
            label: region,
        }))
    );

    // Fetch calls using only city
    fetchCallDetailByRegion(city.value, "");
};

    // const handleRegionChange = (region) => {
    //     setSelectedRegion(region);
    //     setSelectedCalls([]);

    //     if (region && selectedCity) {
    //         fetchCallDetailByRegion(region.value);
    //     } else {
    //         setCallOptions([]);
    //     }
    // };

//     const handleRegionChange = (region) => {
//     setSelectedRegion(region);
//     setSelectedCalls([]);

//     if (region && selectedCity) {
//         fetchCallDetailByRegion(selectedCity.value, region.value);
//     } else {
//         setCallOptions([]);
//     }
// };

const handleRegionChange = (region) => {
    setSelectedRegion(region);
    setSelectedCalls([]);

    if (selectedCity) {
        fetchCallDetailByRegion(
            selectedCity.value,
            region ? region.value : ""
        );
    } else {
        setCallOptions([]);
    }
};
    const handleStateChange = (state) => {
        setSelectedState(state);
        setSelectedCity(null);
        setSelectedRegion(null);
        setRegionOptions([]);
        setSelectedCalls([]);
        setCallOptions([]);

        if (state) {
            fetchDataByState(state.value);
        } else {
            setCityOptions([]);
            setStateData([]);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        const validCallIds = selectedCalls
            .filter(call => call.value !== 'all')
            .map(call => call.value);

        if (!validCallIds.length) {
            showToast("Please select at least one call", 'warning');
            return;
        }

        if (!selectedEmployee) {
            showToast("Please select an employee", 'warning');
            return;
        }

        const payload = {
            callIds: validCallIds,
            empId: selectedEmployee.value
        };

        try {
            const result = await axios.post(
                "https://api.skyguard.group/api/assign-employee-wise-calls",
                payload
            );

            setSelectedCalls([]);
            setSelectedEmployee(null);
            setCallOptions([]);
            fetchCallDetail();
            setSelectedCity(null);
            setSelectedState(null);
            setSelectedRegion(null);
            showToast("Call Assigned Successfully", 'success');

        } catch (error) {
            console.error(error);
            showToast("Fail To Assigned Call", 'danger');
        }
    };

    const fetchDataByState = async (state) => {
        if (!state) return;

        try {
            const response = await axios.get(
                `https://api.skyguard.group/api/get-state-data?state=${encodeURIComponent(state)}`
            );

            const data = response.data;

            if (!data || data.length === 0) {
                setStateData([]);
                setCityOptions([]);
                setPincodeOptions([]);
                showToast("No city available for this state", "warning");
                return;
            }

            setStateData(data);

            // unique cities
            const cityList = [...new Set(data.map(item => item.city))];

            const cityOptionsFormatted = cityList.map(city => ({
                value: city,
                label: city,
            }));

            const pincodeOptionsFormatted = data.map(item => ({
                value: item.pincode,
                label: item.pincode,
            }));


            setCityOptions(cityOptionsFormatted);
            setPincodeOptions(pincodeOptionsFormatted);

        } catch (error) {
            console.error("Error fetching cities by state:", error);
        }
    };



    // const fetchCallDetail = async () => {
    //     try {
    //         const res = await axios.get("https://api.skyguard.group/api/fetch-call-detail");
    //         const filteredData = res.data.filter(item => item.data_type != 'assigned' && item.emp_id == null);
    //         setCalls(filteredData);

    //         const filterAllData = res.data.filter(
    //             c => c.data_type === 'pending' || c.data_type === 'rejected'
    //         );
    //         setDetail(filterAllData);
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const fetchCallDetail = async () => {
    try {
        const res = await axios.get(
            "https://api.skyguard.group/api/fetch-call-detail"
        );

        const unassignedCalls = res.data.filter(item =>
            item.data_type != "assigned"  && 
            (item.emp_id === null || item.emp_id === undefined || item.emp_id === "")
        );

        // For call selection
        setCalls(unassignedCalls);

        // For detail table also
        setDetail(
            unassignedCalls.filter(
                item =>
                    item.data_type === "pending" ||
                    item.data_type === "rejected" ||
                     item.data_type === "reference"
            )
        );

    } catch (error) {
        console.log(error);
    }
};


    const isAllSelected = callOptions.length > 0 && (() => {
        const selectedSet = new Set(selectedCalls.map(s => s.value));
        return callOptions.every(opt => selectedSet.has(opt.value));
    })();

    const handleCallsChange = (selected, actionMeta) => {
        if (actionMeta?.option?.value === 'all') {
            if (isAllSelected) {
                setSelectedCalls([]);
            } else {
                setSelectedCalls(callOptions);
            }
            return;
        }

        if (actionMeta?.action === 'clear') {
            setSelectedCalls([]);
            return;
        }

        setSelectedCalls((selected || []).filter(item => item.value !== 'all'));
    };

    const CheckboxOption = (props) => {
        const isSelected = props.data.value === 'all' ? isAllSelected : props.isSelected;
        return (
            <components.Option {...props} isSelected={isSelected}>
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => null}
                    style={{ marginRight: 8 }}
                />
                <span>{props.label}</span>
            </components.Option>
        );
    };

    const fectEmphDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const filtered = (resEmployee.data.result || []).filter(
                emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
            );

            setUser(filtered);

        } catch (error) {
            console.log(error)
        }
    };

    const fetchStates = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/get-states");
            const options = res.data.map((state) => ({
                value: state,
                label: state,
            }));

            setStateOptions(options);

        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };


    // const fetchCallDetailByRegion = async (region) => {
    //     if (!region) {
    //         setCallOptions([]);
    //         return;
    //     }

    //     try {
    //         const res = await axios.get(
    //             `https://api.skyguard.group/api/fetch-call-detail-region?region=${encodeURIComponent(region)}`
    //         );

    //    const filteredData = res.data.filter(
    //             item =>
    //                 (item.data_type === "pending" ||
    //                     item.data_type === "rejected") &&
    //                 !item.emp_id
    //         );

    //         setCalls(filteredData);

    //         const callOptions = filteredData.map((call, index) => ({
    //             value: call.id,
    //             label: `SR ${index + 1} - ${call.name || call.number}`,
    //             sr_no: index + 1
    //         }));
    //         setCallOptions(callOptions);

    //     } catch (error) {
    //         console.log(error);
    //     }
    // };


//     const fetchCallDetailByRegion = async (city, region) => {
//     if (!city || !region) {
//         setCallOptions([]);
//         return;
//     }

//         console.log("City:", city);
//     console.log("Region:", region);

//     try {
//         const res = await axios.get(
//             `https://api.skyguard.group/api/fetch-call-detail-region?city=${encodeURIComponent(city)}&region=${encodeURIComponent(region)}`
//         );

//         const filteredData = res.data.filter(
//             item =>
//                 (item.data_type === "pending" ||
//                     item.data_type === "rejected") &&
//                 !item.emp_id
//         );

//         setCalls(filteredData);

//         const callOptions = filteredData.map((call, index) => ({
//             value: call.id,
//             label: `SR ${index + 1} - ${call.name || call.number}`,
//             sr_no: index + 1
//         }));

//         setCallOptions(callOptions);

//     } catch (error) {
//         console.log(error);
//     }
// };


const fetchCallDetailByRegion = async (city, region = "") => {
    if (!city) {
        setCallOptions([]);
        return;
    }

    try {
        const params = new URLSearchParams();
        params.append("city", city);

        if (region) {
            params.append("region", region);
        }

        const res = await axios.get(
            `https://api.skyguard.group/api/fetch-call-detail-region?${params.toString()}`
        );

        const filteredData = res.data.filter(
            item =>
                (item.data_type === "pending" ||
                    item.data_type === "reference" ||
                 item.data_type === "rejected") &&
                !item.emp_id
        );

        setCalls(filteredData);

        const options = filteredData.map((call, index) => ({
            value: call.id,
            label: `SR ${index + 1} - ${call.name || call.number}`,
            sr_no: index + 1,
        }));

        setCallOptions(options);
    } catch (error) {
        console.error(error);
    }
};

    useEffect(() => {
        fetchCallDetail();
        fectEmphDetail();
        fetchDataByState();
        fetchStates();
    }, [])

const handleEdit = (row) => {
   
    setEditingId(row.id);
    setEditForm({
        name: row.name,
        number: row.number,
        address: row.address,
        state: row.state,
        city: row.city,
        region: row.region,
        data_type: row.data_type,
        remark: row.remark,
        pincode:row.pincode,
    });
};



const handleEditChange = (field, value) => {
    setEditForm(prev => ({
        ...prev,
        [field]: value
    }));
};


const handleUpdate = async (id) => {
    try {
        await axios.put(
            `https://api.skyguard.group/api/update-call-data-sheet/${id}`,
            editForm
        );
        setEditingId(null);
          fetchCallDetail();

        showToast("Updated Successfully",'success');
    } catch (err) {
        console.error(err);
        showToast("Update failed",'danger');
    }
};

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://api.skyguard.group/api/delete-call-data/${id}`)
            showToast('call data deleted successfully', 'success');
               fetchCallDetail();

        } catch (error) {
            console.error('Error deleting loan:', error);
            showToast('Failed to delete call data', 'danger');
        }
    }
    return (
        <div className='main-section'>

            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <h3 className='my-3 fw-bold fs-5 golos'>All Call Detail</h3>
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-6 col-lg-5">
                        <div className="card shadow-sm p-4 border-0">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-12 mb-3"
                                        >
                                            <label className="form-label fw-medium">
                                                Select Employee
                                            </label>
                                            <Select
                                                options={options}
                                                value={selectedEmployee}
                                                onChange={setSelectedEmployee}
                                                placeholder="Select Employee"
                                                isClearable
                                            />
                                        </div>



                                        <div className="col-12 col-md-6  mb-2">
                                            <label className="form-label fw-medium">State</label>
                                            <Select
                                                options={stateOptions}
                                                value={selectedState}
                                                onChange={handleStateChange}
                                                placeholder="Select State"
                                                isClearable
                                            />
                                        </div>

                                        <div className="col-12 col-md-6  mb-2">
                                            <label className="form-label fw-medium">City</label>
                                            <Select
                                                options={cityOptions}
                                                value={selectedCity}

                                                onChange={handleCityChange}
                                                placeholder="Select City"
                                                isClearable
                                                isDisabled={!selectedState}
                                            />
                                        </div>

                                        <div className="col-12 col-md-6 mb-2">
                                            <label className="form-label fw-medium">Region</label>
                                            <Select
                                                options={regionOptions}
                                                value={selectedRegion}
                                                onChange={handleRegionChange}
                                                placeholder="Select Region"
                                                isClearable
                                                isDisabled={!selectedCity}
                                            />
                                        </div>


                                        <div className="col-12 col-md-6 mb-2">
                                            <label className="form-label fw-medium">Select Calls</label>

                                            <Select
                                                isMulti
                                                options={callOptions.length > 0 ? [selectAllOption, ...callOptions] : []}
                                                value={selectedCalls}
                                                onChange={handleCallsChange}
                                                placeholder="Select calls..."
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                components={{ Option: CheckboxOption }}
                                                classNamePrefix="react-select"
                                                // isDisabled={!selectedRegion}
                                            />

                                        </div>

                                    </div>

                                    <div className="d-flex justify-content-center gap-2 mt-3">
                                        <button type="submit" className="btn btn-success px-4">
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary px-4"

                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className="table table-bordered table-striped text-center table-sm align-middle">
                        <thead className="table-info">
                            <tr>
                                <th>Action</th>
                                <th>SN No</th>
                                <th style={{ width: "120px" }}> Name</th>
                                <th style={{ width: "120px" }}>Phone</th>
                                <th style={{ width: "120px" }}>Address</th>
                                <th style={{ width: "120px" }}>State</th>
                                <th style={{ width: "180px" }}>City</th>
                                <th style={{ width: "120px" }}>Region</th>
                                <th style={{ width: "120px" }}>Status </th>

                                <th style={{ width: "180px" }}>Remark</th>

                            </tr>
                        </thead>
                    

                        <tbody>
    {detail.slice().sort((a, b) => Number(b.id) - Number(a.id)).map((p, i) => (
        <tr key={p.id}>

            <td>
                {editingId === p.id ? (
                    <>
                        <button
                            className="btn btn-success btn-sm"
                            onClick={() => handleUpdate(p.id)}
                        >
                            Update
                        </button>

                        <button
                            className="btn btn-secondary btn-sm ms-2"
                            onClick={() => setEditingId(null)}
                        >
                            Cancel
                        </button>
                    </>
                ) : (
                    <>
                        <AiTwotoneEdit
                            size={20}
                            className="text-primary"
                            onClick={() => handleEdit(p)}
                        />

                        <MdDeleteForever
                            size={20}
                            className=" text-danger"
                             onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Delete Data',
                                                            message: `Are you sure you want to delete "${p.name}"  from call list ?`,
                                                            onConfirm: () => handleDelete(p.id),
                                                        })
                                                    }
                        />
                    </>
                )}
            </td>

            <td>{detail.length - i}</td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.name}
                        onChange={(e) =>
                            handleEditChange("name", e.target.value)
                        }
                    />
                ) : (
                    p.name
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.number}
                        onChange={(e) =>
                            handleEditChange("number", e.target.value)
                        }
                    />
                ) : (
                    p.number
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.address}
                        onChange={(e) =>
                            handleEditChange("address", e.target.value)
                        }
                    />
                ) : (
                    p.address
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.state}
                        onChange={(e) =>
                            handleEditChange("state", e.target.value)
                        }
                    />
                ) : (
                    p.state
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.city}
                        onChange={(e) =>
                            handleEditChange("city", e.target.value)
                        }
                    />
                ) : (
                    p.city
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.region}
                        onChange={(e) =>
                            handleEditChange("region", e.target.value)
                        }
                    />
                ) : (
                    p.region
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.data_type}
                        disabled
                    />
                ) : (
                    p.data_type
                )}
            </td>

            <td>
                {editingId === p.id ? (
                    <input
                        className="form-control"
                        value={editForm.remark}
                        onChange={(e) =>
                            handleEditChange("remark", e.target.value)
                        }
                    />
                ) : (
                    <CiViewList
                        size={26}
                        className="text-primary"
                        title="View Remark"
                        onClick={() => setSelectedRemark(p.remark)}
                        data-bs-toggle="modal"
                        data-bs-target="#remarkModal"
                    />
                )}
            </td>

        </tr>
    ))}
</tbody>

                    </table>
                </div>
                {showVerifyModal && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content border-0 shadow">

                                {/* HEADER */}
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        {step === 1 ? "Confirm Verification" : "Assign Employee"}
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowVerifyModal(false)}
                                    />
                                </div>

                                {/* BODY */}
                                <div className="modal-body">

                                    {/* STEP 1: CONFIRM */}
                                    {step === 1 && (
                                        <div className="text-center">
                                            <MdOutlineVerifiedUser size={40} className="text-primary mb-3" />
                                            <p>
                                                Are you sure you want to <strong>verify this call?</strong>
                                            </p>
                                        </div>
                                    )}

                                    {/* STEP 2: SELECT EMPLOYEE */}
                                    {step === 2 && (
                                        <>
                                            <label className="form-label fw-medium">
                                                Select Employee
                                            </label>
                                            <Select
                                                options={options}
                                                value={selectedEmployee}
                                                onChange={setSelectedEmployee}
                                                placeholder="Select Employee"
                                                isClearable
                                            />
                                        </>
                                    )}

                                </div>

                                {/* FOOTER */}
                                <div className="modal-footer justify-content-center">

                                    {/* STEP 1 BUTTONS */}
                                    {step === 1 && (
                                        <>
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    updateStatus();        // ❌ NOT verified
                                                    setShowVerifyModal(false);
                                                }}
                                            >
                                                No
                                            </button>

                                            <button
                                                className="btn btn-primary"
                                                onClick={() => setStep(2)} // go to next step
                                            >
                                                Yes
                                            </button>
                                        </>
                                    )}

                                    {/* STEP 2 BUTTONS */}
                                    {step === 2 && (
                                        <>
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => setStep(1)}
                                            >
                                                Back
                                            </button>

                                            <button
                                                className="btn btn-success"
                                                disabled={!selectedEmployee}
                                                onClick={handleVerify}
                                            >
                                                Verify & Save
                                            </button>
                                        </>
                                    )}

                                </div>

                            </div>
                        </div>
                    </div>
                )}


                <div className="modal fade" id="remarkModal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title text-primary">Remark</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {selectedRemark}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

    <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />
            </div>
        </div>
    )
}

export default CallDetail